import { API } from "@mobile/api";
import { logger } from "@mobile/lib/logger";
import type { StoreDeps } from "@repo/exit-calc-stores";

export const storeDeps: StoreDeps = { api: API, logger };
